// extracted by mini-css-extract-plugin
module.exports = {"box__message":"MessageError_box__message__2lGjs","register":"MessageError_register__11rXW"};